module.exports = __webpack_public_path__ + "media/images/magnifier-daea7c543e8616a9e7e15b0debd349ec.png";